import {FlightMode} from "../FlightMode";
import {FlightModeGameAssets} from "../FlightModeGameAssets";
import {gsap} from "gsap";
import {SpineGSAPWrapper} from "../misc/SpineGSAPWrapper";

export class MaxWin extends PIXI.Container {

    public maxWinSpine:PIXI.spine.Spine;
    public darkening:PIXI.Sprite;

    constructor() {
        super();

        this.darkening = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.darkening.tint = PIXI.utils.string2hex("#3300ff");
        this.darkening.position.set(360, 360);
        this.darkening.anchor.set(0.5, 0.5);
        this.darkening.alpha = 0;
        this.addChild(this.darkening);

        this.maxWinSpine = new PIXI.spine.Spine(FlightMode.assetLoader.getSpineAsset(FlightModeGameAssets.MAX_WIN_SPINE));
        this.maxWinSpine.position.set(360, 360);
        this.maxWinSpine.alpha = 0;
        this.addChild(this.maxWinSpine);
    }

    public show():gsap.core.Timeline {
        const animationNumber = FlightMode.seedableRandom.nextInt(6) + 1;
        return gsap.timeline()
            .add(!FlightMode.model.anyWinningSymbols()
                 ? gsap.timeline()
                    .add(FlightMode.reelView.getMaxWinSymbols().map((sym, index) =>  {
                        return gsap.timeline()
                            .add(FlightMode.reelView.moveUpSymbol(sym))
                            .add(sym.winMaxWin())
                            .add(FlightMode.reelView.moveDownSymbol(sym))
                    }))
                 : gsap.timeline())
            .add(gsap.to(this.darkening, {alpha: 0.7, duration: 0.25}))
            .add(SpineGSAPWrapper.createTimeline(this.maxWinSpine, 0, `MW_Intro_${animationNumber}`))
            .add(() => {
                this.maxWinSpine.alpha = 1;
            }, '<')
            .add(() => {
                this.maxWinSpine.state.setAnimation(0, `MW_Loop_${animationNumber}`, true);
            });
    }

    public hide():gsap.core.Timeline {
        return gsap.timeline()
            .add(gsap.to(this.darkening, {alpha: 0, duration: 0.25}))
            .add(() => {
                this.maxWinSpine.state.setEmptyAnimation(0, 0);
                this.maxWinSpine.alpha = 0;
            });
    }
}